import { useEffect } from "react";
import { useWebsite } from "../../../context/WebsiteContext";

import { contract } from "@react95/core";

import { CSSProperties } from "react";

type WebInputProps = {
  placeholder?: string;
  style?: CSSProperties;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent) => void;
};

type WebButtonProps = {
  label: string;
  style?: CSSProperties;
  onClick?: () => void;
  disabled?: boolean;
};

export function WebInput(props: WebInputProps) {
  return (
    <input
      type="text"
      placeholder={props.placeholder}
      style={{
        padding: "2px",
        fontFamily: "Arial, sans-serif",
        fontSize: "14px",
        border: 0,
        borderRadius: 0,
        boxSizing: "border-box",
        boxShadow: `inset 1px 1px 0 0 ${contract.colors.borderDark}`,
        outline: "none",
        ...props.style,
      }}
      value={props.value}
      onChange={props.onChange}
      onKeyDown={props.onKeyDown}
    />
  );
}

export function WebButton(props: WebButtonProps) {
  return (
    <button
      disabled={props.disabled}
      style={{
        borderRadius: 0,
        padding: "4px 8px",
        fontFamily: "Arial, sans-serif",
        fontSize: "13px",
        cursor: props.disabled ? "not-allowed" : "pointer",
        opacity: props.disabled ? 0.6 : 1,
        border: 0,
        backgroundColor: contract.colors.material,

        boxShadow: `inset 1px 1px 0px 1px ${contract.colors.borderLightest},
    inset 0 0 0 1px ${contract.colors.borderDark},
    1px 1px 0 0px ${contract.colors.borderDarkest}`,

        ...props.style,
      }}
      onClick={props.onClick}
    >
      {props.label}
    </button>
  );
}
